export default __webpack_public_path__ + "static/media/simon.3023ca8c.png";